export default function PortfolioField({ visibleFields, value, onChange, showValidation }) {
  const field = visibleFields.find((f) => f.id === "portfolio");
  if (!field) return null;
  
  const isMandatory = field.mandatory === true;
  const isEmpty = !value || value.trim() === "";
  const showError = showValidation && isMandatory && isEmpty;
  
  return (
    <div className="flex flex-col">
      <label htmlFor={field.id} className="input-label">
        {field.label} {isMandatory && "*"}
      </label>
      <input
        type="url"
        id={field.id}
        name={field.id}
        value={value || ""}
        onChange={onChange}
        className={`input ${showError ? "border-red-500" : ""}`}
        placeholder="https://yourportfolio.com"
      />
    </div>
  );
}


